import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 4rem;
  align-items: center;
  gap: 1rem;
`;

const LabelLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.1rem;
  color: #cbd5e1;
  margin-bottom: 0.4rem;

  strong { color: #f1f5f9; font-weight: 600; }
`;

const BarTrack = styled.div`
  height: 0.7rem;
  background: rgba(255,255,255,0.05);
  border-radius: 9999px;
  overflow: hidden;
`;

const BarFill = styled.div`
  height: 100%;
  background: ${(p) => p.color};
  width: ${(p) => p.pct}%;
  transition: width 0.4s ease;
`;

const Pct = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: #94a3b8;
  text-align: right;
  font-variant-numeric: tabular-nums;
`;

const Empty = styled.div`
  font-size: 1.2rem;
  color: #64748b;
  text-align: center;
  padding: 2rem 0;
`;

const REASON_META = {
  customer_no_answer: { label: '📵 Customer no-answer', color: '#f59e0b' },
  doctor_no_answer:   { label: '📵 Agent no-answer',     color: '#3b82f6' },
  failed:             { label: '❌ Failed',              color: '#ef4444' },
  outside_business_hours: { label: '🕐 Outside hours',   color: '#8852cc' },
  no_doctor:          { label: '👥 No agent available',  color: '#a78bfa' },
  no_doctor_available:{ label: '👥 No agent available',  color: '#a78bfa' },
  enqueued_manually:  { label: '🔁 Manually queued',     color: '#22c55e' },
  system_failure:     { label: '⚠️ System failure',      color: '#ef4444' },
};

/**
 * Horizontal-bar breakdown of failure reasons.
 * Props:
 *   rows: [{ reason, count }]
 */
const ReasonBreakdown = ({ rows = [] }) => {
  if (!rows.length) {
    return <Empty>No failures to break down — clean slate today.</Empty>;
  }

  const total = rows.reduce((s, r) => s + Number(r.count || 0), 0);

  return (
    <Wrap>
      {rows.map((r) => {
        const meta = REASON_META[r.reason] || { label: r.reason, color: '#64748b' };
        const pct = total > 0 ? (Number(r.count || 0) / total) * 100 : 0;
        return (
          <div key={r.reason}>
            <LabelLine>
              <span>{meta.label}</span>
              <strong>{r.count}</strong>
            </LabelLine>
            <Row>
              <BarTrack>
                <BarFill color={meta.color} pct={pct} />
              </BarTrack>
              <Pct>{pct.toFixed(0)}%</Pct>
            </Row>
          </div>
        );
      })}
    </Wrap>
  );
};

export default ReasonBreakdown;
